import { useState } from 'react';
import { Avatar, Button, Typography } from 'antd';
import { useGlobal } from 'src/contexts/GlobalContext';

import { UserOutlined } from '@ant-design/icons';

import SidebarMobile from '../Sidebar/SidebarMobile';
import { Header } from './AppHeader.styled';
import ClientSwitcher from '../ClientSwitcher/ClientSwitcher';
import { FlexGap16 } from '../CommonStyledComponents/CommonStyledComponents.styled';
import UserProfile from '../UserProfile/UserProfile';
import MobileUserProfile from '../UserProfile/MobileUserProfile';
import NotificationPopover from './components/NotificationPopover';
import { useAuth } from 'src/contexts/AuthContext';
import { usePermission } from 'src/hooks/usePermission';
import { useClient } from 'src/api/axios/config';
import { useTranslation } from 'react-i18next';

export const AppHeader = () => {
  const { isDesktop } = useGlobal();
  const { currentUser: userData } = useAuth();
  const { hasPermission } = usePermission();
  const client = useClient();
  const { t } = useTranslation();

  const [isUserProfileModalVisible, setIsUserProfileModalVisible] = useState(false);

  const fullName = userData ? `${userData.firstName ?? ''} ${userData.lastName ?? ''}`.trim() : '';

  const toggleUserProfileModal = () => setIsUserProfileModalVisible((prev) => !prev);

  const isSuperAdmin = client === 'support';

  return (
    <Header>
      {!isDesktop && <SidebarMobile />}
      {!isSuperAdmin ? (
        <ClientSwitcher />
      ) : (
        <Typography.Text type="secondary">{t('general.superAdmin')}</Typography.Text>
      )}
      <FlexGap16 align="center">
        {hasPermission('alert:reader', 'alert:manager') ? <NotificationPopover /> : null}

        {isDesktop ? <Typography.Text>{fullName}</Typography.Text> : null}
        {isDesktop ? (
          <UserProfile visible={isUserProfileModalVisible} toggleUserProfile={toggleUserProfileModal} />
        ) : (
          <>
            <Button data-testid="profile-btn" shape="circle" onClick={toggleUserProfileModal}>
              <Avatar icon={<UserOutlined />} />
            </Button>
            <MobileUserProfile drawerVisible={isUserProfileModalVisible} toggleDrawer={toggleUserProfileModal} />
          </>
        )}
      </FlexGap16>
    </Header>
  );
};
